import React, { useState, useEffect } from "react";
import {
  Avatar,
  Avatargroup,
  Box,
  Button,
  Calendar,
  Dropdown,
  DropdownItem,
  getColor,
  Icons,
  Modal,
  Tabs,
  Tooltip,
  Typography,
  useToast,
} from "fds";
import "./index.scss";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
import { Workgroup } from "../../types/workgroup";
import utilsCommon from "../../shared/utils/common";
import { useNavigate, useParams } from "react-router-dom";
import WorkgroupHome from "./WorkgroupHome";
import WorkgroupFile from "./WorkgroupFile";
import WorkgroupChat from "./WorkgroupChat";
import WorkgroupMeeting from "./WorkgroupMeeting";
import WorkgroupLog from "./WorkgroupLog";
import { getUserInfoFromLocalStorage } from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";
import WorkgroupInfoModal from "../../components/WorkgroupModal";
import WorkgroupAddModal from "../../components/WorkgroupAddModal";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import ProgressBar from "../../components/ProgressBar";
import { handleSetFavorite } from "../../shared/utils/api";
import { MenuListType } from "../../types/files";
import classNames from "classnames";
import WorkgroupDeleteModal from "../../components/WorkgroupModal/WorkgroupDeleteModal";
import { expireType_policy_type } from "../../components/WorkgroupModal/WorkgroupInfoSettingTab";
import dayjs, { ManipulateType } from "dayjs";
import LeaveWorkgroupModal from "../../components/WorkgroupSettingButton/LeaveWorkgroupModal";
import { t } from "i18next";

const WorkgroupPage = () => {
  const TAB_VALUES = [
    {
      key: "home",
      resource: t("common.home"),
      index: 0,
      hidden:
        utilsCommon.checkMenuAvailable("zoom") === false &&
        utilsCommon.getChatAvailibility() === "noDisplay",
    },
    { key: "file", resource: t("common.file"), index: 1, hidden: false },
    {
      key: "chat",
      resource: t("common.chat"),
      index: 2,
      hidden: utilsCommon.getChatAvailibility() === "noDisplay",
    },
    {
      key: "meeting",
      resource: t("common.meetings"),
      index: 3,
      hidden: utilsCommon.checkMenuAvailable("zoom") === false,
    },
    { key: "log", resource: t("common.log"), index: 4, hidden: false },
  ];
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const myId = loginDto?.userInfo?.userId ?? "";
  const params = useParams();
  const navigate = useNavigate();
  let menus = [
    {
      key: "workgroupInfo_user",
      resource: t("file.detail"),
      icon: <Icons variant="line" label="detailInfo" />,
      onClick: () => changeModalType("WORKGROUPDETAIL_USER"),
    },
    {
      key: "workgroupInfo_master",
      resource: t("workgroup.setting"),
      icon: <Icons variant="line" label="setting" />,
      onClick: () => changeModalType("WORKGROUPDETAIL_MASTER"),
    },
    {
      key: "workgroupFav",
      resource: t("workgroup.unfavWorkgroup"),
      icon: <Icons variant="line" label="star" isOn />,
      onClick: () => {
        handleSetFavorite(
          workgroupInfo?.workgroupId,
          updateWorkgroupFavorite,
          workgroupState.workgroupSidemenuList ?? []
        );
        changeButtonClick(buttonClick + 1);
      },
    },
    {
      key: "workgroupUnFav",
      resource: t("workgroup.favWorkgroup"),
      icon: <Icons variant="fill" label="star" isColored />,
      onClick: () => {
        handleSetFavorite(
          workgroupInfo?.workgroupId,
          updateWorkgroupFavorite,
          workgroupState.workgroupSidemenuList ?? []
        );
        changeButtonClick(buttonClick + 1);
      },
    },
    {
      key: "renameWorkgroup",
      resource: t("common.rename"),
      icon: <Icons variant="line" label="edit2" />,
      onClick: () => changeModalType("WORKGROUPDETAIL_MASTER"),
    },
    { key: "divider_workgroup" },
    {
      key: "exitWorkgroup",
      resource: t("workgroup.exit"),
      icon: <Icons variant="line" label="exit" />,
      onClick: () => changeModalType("EXIT_WORKGROUP"),
    },
  ] as {
    key: MenuListType;
    resource: string;
    icon: React.ReactNode;
    onClick?: () => void;
  }[];
  const toast = useToast();
  const { documentState } = useDocumentStore();
  const {
    workgroupState,
    getWorkgroupDetail,
    updateWorkgroupFavorite,
    withdrawMember,
    updateWorkgroupInfo,
  } = useWorkgroupStore();

  const [modalType, changeModalType] = useState("CLOSE");
  const [workgroupInfo, changeWorkgorupInfo] = useState<
    Workgroup | undefined
  >();
  const [buttonClick, changeButtonClick] = useState(0);
  const [tab, changeTab] = useState(-1); // -1 로 해야 다른 탭으로 접근해도 home에 있는 API 들 호출 안함
  const [openExtraModal, changeOpenExtraModal] = useState("CLOSE");
  const [expireDateFilter, changeExpireDateFilter] = useState("-1");
  useEffect(() => {
    if (params.workgroupId) {
      getWorkgroupDetail({ workgroupId: params.workgroupId });
    }
  }, [params.workgroupId]);
  useEffect(() => {
    changeTab(
      TAB_VALUES.filter((item) => item.hidden === false).filter(
        (tab) => tab.key === (params.tab ?? "home")
      )[0]?.index ?? 0
    );
  }, [window.location.href, params]);
  useEffect(() => {
    changeWorkgorupInfo(workgroupState?.workgroupDetail?.workgroup);
    changeExpireDateFilter("-1");
  }, [workgroupState.workgroupDetail]);
  /** 유효기간 설정 */
  const handleWorkgroupExpireDate = (key: string) => {
    changeExpireDateFilter(key);
    changeButtonClick(buttonClick + 1);
    if (key === "custom") {
      workgroupInfo &&
        changeWorkgorupInfo({
          ...workgroupInfo,
          endDate: dayjs().endOf("day").valueOf(),
        });
    } else if (key !== "-1") {
      const numValue = parseInt(key.split("_")[0]);
      const strValue = key.split("_")[1] as ManipulateType;
      workgroupInfo &&
        changeWorkgorupInfo({
          ...workgroupInfo,
          endDate: dayjs().add(numValue, strValue).endOf("day").valueOf(),
        });
    } else {
      workgroupInfo &&
        changeWorkgorupInfo({
          ...workgroupInfo,
          endDate: -1,
        });
    }
  };
  const renderWorkgroupHeader = () => {
    const workgroupMasterMe = workgroupInfo?.managerId === myId;
    return (
      <Box height={110} minHeight={110} alignItems="center">
        {modalType === "EXIT_WORKGROUP" ? (
          <LeaveWorkgroupModal
            open={modalType === "EXIT_WORKGROUP"}
            onClose={() => changeModalType("CLOSE")}
            withdrawMember={withdrawMember}
            workgroupInfo={workgroupInfo}
          />
        ) : (
          modalType.includes("WORKGROUP") && (
            <WorkgroupInfoModal
              open={true}
              startTab={modalType.split("_")[1]}
              isWorkgroupManager={workgroupMasterMe}
              workgroupInfo={workgroupInfo}
              onClose={() => changeModalType("CLOSE")}
            />
          )
        )}
        {modalType === "ADD_NEW_MEMBER" && (
          <WorkgroupAddModal
            createType={"ADD_NEW_MEMBER"}
            open
            disableValues={workgroupInfo?.members?.map((item) => item.userId)}
            workgroupInfo={workgroupInfo}
            onClose={() => changeModalType("CLOSE")}
          />
        )}
        <Avatar
          uniqueCode={workgroupInfo?.workgroupId ?? ""}
          name={workgroupInfo?.workgroupName}
          shape="workgroup"
          size="48"
        />
        <Box
          direction="column"
          classes="mg ml-12"
          width={"calc(100% - 500px)"}
          maxWidth={"calc(100% - 500px)"}
        >
          <Box alignItems="center">
            <Tooltip
              message={workgroupInfo?.workgroupName}
              maxWidth={"calc(100% - 32px)"}
            >
              <Typography type="h2" ellipsis>
                {workgroupInfo?.workgroupName}
              </Typography>
            </Tooltip>
            <Tooltip
              message={
                workgroupInfo?.favorite === "N"
                  ? t("file.action.addFav")
                  : t("file.action.removeFav")
              }
            >
              <Button
                btnStyle="icon"
                onClick={() =>
                  handleSetFavorite(
                    workgroupInfo?.workgroupId,
                    updateWorkgroupFavorite,
                    workgroupState.workgroupSidemenuList
                  )
                }
                leadingIcon={
                  workgroupInfo?.favorite === "N" ? (
                    <Icons variant="line" label="star" isOn />
                  ) : (
                    <Icons variant="fill" label="star" isColored />
                  )
                }
              />
            </Tooltip>
          </Box>
          {workgroupInfo?.desc ? (
            <Tooltip message={workgroupInfo?.desc}>
              <Typography
                type="body2_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
                classes="mg mt-2"
                ellipsis
              >
                {workgroupInfo?.desc}
              </Typography>
            </Tooltip>
          ) : workgroupMasterMe ? (
            <Typography
              type="body2_rg"
              classes="hover-text-underline"
              width={"fit-content"}
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
              onClick={() => changeModalType("WORKGROUPDETAIL_MASTER")}
            >
              {t("workgroup.addDesc")}
            </Typography>
          ) : (
            ""
          )}
        </Box>
        <Box classes="mg ml-auto">
          <Tooltip
            maxWidth={
              22 *
              (workgroupInfo?.members?.length
                ? Math.min(workgroupInfo?.members?.length, 9)
                : 0)
            }
            message={
              <Box direction="column">
                <Typography type="body4_rg" fontWeight={700} exactColor="white">
                  {t("workgroup.seeAll", {
                    length: workgroupInfo?.members?.length,
                  })}
                </Typography>
                <Typography
                  type="body4_rg"
                  exactColor="white"
                  classes="mg mt-4"
                >
                  {workgroupInfo?.members
                    ?.map((member) => member?.userName || member.userId)
                    .join(", ")}
                </Typography>
              </Box>
            }
          >
            <Avatargroup
              size="24"
              visibleLength={8}
              classes="cursor pointer"
              onClick={() => changeModalType("WORKGROUP_members")}
              items={utilsCommon.sortMembersToAvatarGroup(
                workgroupInfo?.members,
                workgroupInfo?.managerId
              )}
            />
          </Tooltip>
          <Box classes="mg ml-12">
            {utilsCommon.checkMenuAvailble("inviteUser", workgroupInfo) && (
              <Tooltip message={t("workgroup.addMember")}>
                <Button
                  onClick={() => changeModalType("ADD_NEW_MEMBER")}
                  leadingIcon={<Icons variant="line" label="addPerson" />}
                  btnStyle="icon"
                />
              </Tooltip>
            )}
            {workgroupMasterMe && (
              <Tooltip message={t("workgroup.setting")}>
                <Button
                  leadingIcon={<Icons variant="line" label={"setting"} />}
                  btnStyle="icon"
                  onClick={() => changeModalType("WORKGROUP_MASTER")}
                  classes="mg ml-4"
                />
              </Tooltip>
            )}
            <Dropdown
              align="right"
              width={190}
              buttonClick={buttonClick}
              classes="mg ml-4"
              btnIcon={<Icons variant="line" label="moreVertical" />}
            >
              {menus
                .filter((item) =>
                  utilsCommon.checkMenuAvailble(item.key, workgroupInfo)
                )
                .map((item) => (
                  <DropdownItem
                    height={item.key.includes("divider") ? undefined : 20}
                    type={item.key === "exitWorkgroup" ? "warning" : "default"}
                    state={item.key.includes("divider") ? "divider" : "default"}
                    label={item.resource}
                    frontIcon={item.icon}
                    onClick={item.onClick}
                  />
                ))}
            </Dropdown>
          </Box>
        </Box>
      </Box>
    );
  };
  const renderExpiredLayer = () => {
    return (
      <Box classes="isExpired">
        <Box height={52} alignItems="center" classes="isExpired-header">
          <Icons variant="line" label="alertCircle" stroke="white" />
          <Typography exactColor="white" type="body2_rg" classes="mg ml-8">
            {t("workgroup.expired.info")}
          </Typography>
          <Typography
            exactColor={getColor("COLOR_TEXT_ERROR_LIGHT")}
            type="body2_rg"
            classes="cursor pointer mg ml-auto"
            onClick={() => changeOpenExtraModal("DELETE_WORKGROUP")}
          >
            {t("workgroup.deleteWorkgroup")}
          </Typography>
          <Typography
            exactColor={"white"}
            classes="mg ml-16 cursor pointer"
            type="body2_rg"
            onClick={() => changeOpenExtraModal("EXTEND_EXPIRE_DATE")}
          >
            {t("workgroup.expired.extendExpired")}
          </Typography>
        </Box>
        <Box classes="isExpired-background" />
        <Box
          direction="column"
          alignItems="center"
          justifyContent="center"
          width={"100%"}
          style={{ position: "absolute", zIndex: 3 }}
          height={"100%"}
        >
          <img
            width={360}
            height={200}
            alt={"Home"}
            src={require("../../shared/images/pages/Workgroup/expiredWorkgroup.png")}
          />
          <Typography
            type="subtitle2"
            exactColor={getColor("COLOR_TEXT_PRIMARY")}
            whiteSpace="pre"
            textAlign="center"
          >
            {t("workgroup.expired.desc")}
          </Typography>
        </Box>
      </Box>
    );
  };
  const handleExtendExpiredDate = async () => {
    if (!workgroupInfo) return;
    await updateWorkgroupInfo({
      workgroupId: workgroupInfo?.workgroupId,
      workgroup: {
        ...workgroupInfo,
        endDate: expireDateFilter === "-1" ? -1 : workgroupInfo?.endDate,
      },
    });
    window.location.reload();
  };
  return (
    <Box width={"100%"} height={"100%"} classes={classNames("workgroup body")}>
      {workgroupInfo?.isValidate === 0 && renderExpiredLayer()}
      {openExtraModal === "DELETE_WORKGROUP" && (
        <WorkgroupDeleteModal
          open={openExtraModal === "DELETE_WORKGROUP"}
          workgroupInfo={workgroupInfo}
          onClose={() => changeOpenExtraModal("CLOSE")}
        />
      )}
      {openExtraModal === "EXTEND_EXPIRE_DATE" && (
        <Modal
          open={openExtraModal === "EXTEND_EXPIRE_DATE"}
          title={t("workgroup.expired.extendTitle")}
          width={540}
          onClose={() => changeOpenExtraModal("CLOSE")}
          body={
            <Box direction="column">
              <Dropdown
                placeholder="s"
                value={
                  expireType_policy_type.filter(
                    (item) => item?.key === expireDateFilter
                  )[0]?.resource
                }
                positionStrategy="fixed"
                classes="mg mt-6"
                buttonClick={buttonClick}
              >
                {expireType_policy_type.map((item) => (
                  <DropdownItem
                    label={item.resource}
                    key={item?.key}
                    type="check"
                    checkColor={expireDateFilter === item?.key}
                    checked={expireDateFilter === item?.key}
                    onClick={() => handleWorkgroupExpireDate(item?.key)}
                  />
                ))}
              </Dropdown>
              {expireDateFilter === "custom" ? (
                <Box alignItems="center" classes="mg mt-8 mb-22 expiredDate">
                  <Calendar
                    type={"single"}
                    placeholder={t("common.selectDate")}
                    width={200}
                    selected={
                      workgroupInfo?.endDate
                        ? new Date(workgroupInfo?.endDate)
                        : undefined
                    }
                    minDate={new Date()}
                    // popperPlacement="fixed"
                    onSubmit={(date) =>
                      workgroupInfo &&
                      changeWorkgorupInfo({
                        ...workgroupInfo,
                        endDate: dayjs(date instanceof Date ? date : "")
                          .endOf("day")
                          .valueOf(),
                      })
                    }
                  />
                  <Typography type="body2_rg" classes="mg ml-8 ">
                    {t("workgroup.untilNoDate")}
                  </Typography>
                </Box>
              ) : (
                expireDateFilter !== "-1" && (
                  <Box alignItems="center" classes="mg mt-6">
                    <Icons variant="line" label="info" size="20px" />
                    <Typography type="body2_rg" classes="mg ml-2">
                      {t("workgroup.until", {
                        date: utilsCommon.renderShortDateFormat(
                          workgroupInfo?.endDate
                        ),
                      })}
                    </Typography>
                  </Box>
                )
              )}
            </Box>
          }
          footer={
            <Box>
              <Button
                label={t("common.cancel")}
                btnStyle="fill"
                type="secondary"
                onClick={() => changeOpenExtraModal("CLOSE")}
              />
              <Button
                label={t("common.save")}
                btnStyle="fill"
                onClick={handleExtendExpiredDate}
              />
            </Box>
          }
        />
      )}
      {renderWorkgroupHeader()}
      <Tabs
        tabs={TAB_VALUES.map((item) => {
          return {
            text: item.resource,
            color: "default",
            isHidden: item.hidden,
          };
        })}
        selectTab={(tab) => {
          navigate(
            `${process.env.PUBLIC_URL}/workgroup/${params.workgroupId}/${TAB_VALUES[tab].key}`
          );
        }}
        selected={tab}
        type="leftFull"
        size={"lg"}
      />
      {tab === 0 ? (
        <WorkgroupHome workgroupId={params.workgroupId ?? ""} />
      ) : tab === 1 ? (
        <WorkgroupFile workgroupId={params.workgroupId ?? ""} />
      ) : tab === 2 ? (
        <WorkgroupChat workgroupInfo={workgroupInfo} />
      ) : tab === 3 ? (
        <WorkgroupMeeting workgroupId={params.workgroupId ?? ""} />
      ) : (
        <WorkgroupLog workgroupId={params.workgroupId ?? ""} />
      )}
      {documentState.uploadDocsProgress.uploadFiles.length > 0 &&
        !documentState.uploadDocsProgress.isMultiple && (
          <ProgressBar
            position="bottom"
            progressItems={documentState.uploadDocsProgress}
          />
        )}
    </Box>
  );
};

export default WorkgroupPage;
